import React,{useCallback,useEffect,useMemo,useState} from 'react';
import {api,ApiError} from './api';

const card={background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18};
const input={padding:'10px 12px',border:'1px solid #cbd5e1',borderRadius:7,width:'100%',boxSizing:'border-box'};
const btn={padding:'9px 13px',border:0,borderRadius:7,color:'#fff',fontWeight:700,cursor:'pointer'};
const th={textAlign:'left',padding:'10px',borderBottom:'2px solid #e2e8f0',fontSize:12,color:'#475569'};
const td={padding:'10px',borderBottom:'1px solid #f1f5f9',fontSize:13};

function etiquetaDeposito(d){
  return `${d.empresa_nombre} · ${d.sucursal_nombre} · ${d.nombre}`;
}

export default function Transferencias({usuario}){
  const [lista,setLista]=useState([]);
  const [opciones,setOpciones]=useState({depositos:[],deposito_origen_id:null});
  const [productos,setProductos]=useState([]);
  const [error,setError]=useState('');
  const [mensaje,setMensaje]=useState('');
  const [form,setForm]=useState({origen:'',destino:'',producto:'',cantidad:'1',observaciones:''});
  const [items,setItems]=useState([]);

  const cargar=useCallback(async()=>{
    try{
      setError('');
      const [t,o,p]=await Promise.all([
        api.get('/api/transferencias'),
        api.get('/api/transferencias/opciones'),
        api.get('/api/productos'),
      ]);
      setLista(Array.isArray(t)?t:[]);
      setOpciones(o||{depositos:[]});
      setProductos(Array.isArray(p)?p:(p?.productos||[]));
      const deps=o?.depositos||[];
      const origen=String(o?.deposito_origen_id||usuario?.deposito_id||'');
      const destino=deps.find(d=>Number(d.id)!==Number(origen))?.id;
      setForm(f=>({...f,origen,destino:f.destino||String(destino||'')}));
    }catch(e){
      setError(e instanceof ApiError?e.mensaje:'No se pudieron cargar las transferencias.');
    }
  },[usuario?.deposito_id]);

  useEffect(()=>{cargar();},[cargar]);

  const deps=opciones.depositos||[];
  const origen=deps.find(d=>Number(d.id)===Number(form.origen));
  const destinos=deps.filter(d=>Number(d.id)!==Number(form.origen));
  const producto=useMemo(()=>productos.find(p=>Number(p.id)===Number(form.producto)),[productos,form.producto]);

  const agregar=()=>{
    const cantidad=Number(form.cantidad);
    if(!producto||!Number.isFinite(cantidad)||cantidad<=0){setError('Elegí un producto y una cantidad válida.');return;}
    setItems(prev=>{
      const existe=prev.find(i=>Number(i.producto_id)===Number(producto.id));
      return existe
        ?prev.map(i=>Number(i.producto_id)===Number(producto.id)?{...i,cantidad:Number(i.cantidad)+cantidad}:i)
        :[...prev,{producto_id:producto.id,descripcion:producto.descripcion,cantidad}];
    });
    setForm(f=>({...f,producto:'',cantidad:'1'}));
  };

  const crear=async()=>{
    try{
      setError('');setMensaje('');
      if(Number(form.origen)===Number(form.destino)) throw new Error('Origen y destino deben ser distintos.');
      const r=await api.post('/api/transferencias',{
        deposito_origen_id:Number(form.origen),
        deposito_destino_id:Number(form.destino),
        observaciones:form.observaciones,
        items,
      });
      setMensaje(`Transferencia #${r.transferencia_id} creada (${r.tipo==='interempresa'?'entre empresas':'interna'}).`);
      setItems([]);setForm(f=>({...f,producto:'',cantidad:'1',observaciones:''}));
      await cargar();
    }catch(e){setError(e.mensaje||e.message||'No se pudo crear la transferencia.');}
  };

  const accion=async(id,tipo)=>{
    try{
      setError('');setMensaje('');
      await api.post(`/api/transferencias/${id}/${tipo}`,{});
      setMensaje(tipo==='enviar'?'Transferencia despachada y stock descontado del origen.':'Transferencia recibida y stock incorporado al destino.');
      await cargar();
    }catch(e){setError(e.mensaje||'No se pudo completar la operación.');}
  };

  return <div style={{display:'grid',gap:18}}>
    <div><h2 style={{margin:'0 0 6px'}}>Transferencias de stock</h2>
      <p style={{margin:0,color:'#64748b'}}>Mové mercadería entre depósitos de Casa Alessio y MKiosco24. El despacho descuenta el origen y la recepción acredita el destino.</p>
    </div>
    {error&&<div style={{...card,background:'#fef2f2',color:'#b91c1c'}}>{error}</div>}
    {mensaje&&<div style={{...card,background:'#f0fdf4',color:'#166534'}}>{mensaje}</div>}

    <section style={card}>
      <h3 style={{marginTop:0}}>Nueva transferencia</h3>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(240px,1fr))',gap:10}}>
        <div><label style={label}>Origen (contexto activo)</label><input style={{...input,background:'#f8fafc'}} value={origen?etiquetaDeposito(origen):'Sin depósito activo'} readOnly/></div>
        <div><label style={label}>Destino</label><select style={input} value={form.destino} onChange={e=>setForm({...form,destino:e.target.value})}>
          <option value="">Seleccionar empresa y depósito...</option>
          {destinos.map(d=><option key={d.id} value={d.id}>{etiquetaDeposito(d)}{Number(d.empresa_id)!==Number(usuario?.empresa_id)?' · INTEREMPRESA':''}</option>)}
        </select></div>
        <div><label style={label}>Observaciones</label><input style={input} placeholder="Remito, motivo o referencia" value={form.observaciones} onChange={e=>setForm({...form,observaciones:e.target.value})}/></div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'minmax(220px,1fr) 120px auto',gap:10,marginTop:12}}>
        <select style={input} value={form.producto} onChange={e=>setForm({...form,producto:e.target.value})}>
          <option value="">Producto de {usuario?.empresa_nombre||'la empresa activa'}</option>
          {productos.map(p=><option key={p.id} value={p.id}>{p.descripcion}</option>)}
        </select>
        <input style={input} type="number" min="0.001" step="0.001" value={form.cantidad} onChange={e=>setForm({...form,cantidad:e.target.value})}/>
        <button type="button" style={{...btn,background:'#475569'}} onClick={agregar}>Agregar</button>
      </div>
      {items.length>0&&<div style={{marginTop:12}}>
        {items.map(i=><div key={i.producto_id} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f1f5f9'}}>
          <span>{i.descripcion}</span><span>{i.cantidad} <button onClick={()=>setItems(items.filter(x=>x.producto_id!==i.producto_id))} style={{border:0,background:'none',color:'#dc2626',cursor:'pointer'}}>Quitar</button></span>
        </div>)}
        <button onClick={crear} disabled={!form.origen||!form.destino||!items.length} style={{...btn,background:'#2563eb',marginTop:14}}>Guardar borrador</button>
      </div>}
    </section>

    <section style={card}><h3 style={{marginTop:0}}>Historial</h3><div style={{overflowX:'auto'}}><table style={{width:'100%',borderCollapse:'collapse'}}>
      <thead><tr>{['Remito','Origen','Destino','Tipo','Estado','Ítems','Fecha','Acciones'].map(h=><th key={h} style={th}>{h}</th>)}</tr></thead>
      <tbody>{lista.map(t=><tr key={t.id}>
        <td style={td}>{t.numero_remito||`#${t.id}`}</td>
        <td style={td}><b>{t.origen_empresa}</b><br/><small>{t.origen_sucursal} · {t.origen_nombre}</small></td>
        <td style={td}><b>{t.destino_empresa}</b><br/><small>{t.destino_sucursal} · {t.destino_nombre}</small></td>
        <td style={td}>{t.tipo==='interempresa'?<span style={pill('#7c3aed','#f3e8ff')}>Interempresa</span>:<span style={pill('#0369a1','#e0f2fe')}>Interna</span>}</td>
        <td style={td}><b>{t.estado}</b></td><td style={td}>{t.items}</td>
        <td style={td}>{new Date(t.creado_en).toLocaleString('es-AR')}</td>
        <td style={td}>
          {t.estado==='Borrador'&&Number(t.deposito_origen_id)===Number(usuario?.deposito_id)&&<button style={{...btn,background:'#d97706'}} onClick={()=>accion(t.id,'enviar')}>Enviar</button>}
          {t.estado==='En tránsito'&&Number(t.deposito_destino_id)===Number(usuario?.deposito_id)&&<button style={{...btn,background:'#059669'}} onClick={()=>accion(t.id,'recibir')}>Recibir</button>}
        </td>
      </tr>)}
      {!lista.length&&<tr><td colSpan="8" style={{padding:20,textAlign:'center',color:'#64748b'}}>No hay transferencias para este contexto.</td></tr>}
      </tbody></table></div></section>
  </div>;
}

const label={display:'block',fontSize:12,fontWeight:700,color:'#475569',marginBottom:5};
const pill=(color,background)=>({color,background,padding:'4px 8px',borderRadius:12,fontSize:11,fontWeight:700});
